<app-button-delete-contract
  [contract]="contract()"
  (contractDeleted)="contractDeleted.emit($event)"
></app-button-delete-contract>
@if (!contract().deleted) {
  <app-button-cancel-validation-request
    [contract]="contract()"
  ></app-button-cancel-validation-request>
  <app-button-request-validation
    [contract]="contract()"
    validationType="REX_VALIDATION"
  ></app-button-request-validation>
  @for (validationType of ValidationRequestTypes; track $index) {
    <app-button-refuse-validation-request
      [contract]="contract()"
      [validationType]="validationType"
    ></app-button-refuse-validation-request>
    <app-button-accept-and-request-validation
      [contract]="contract()"
      [acceptValidationType]="validationType"
    ></app-button-accept-and-request-validation>
  }
  <app-button-accept-validation-request
    [contract]="contract()"
    validationType="DRH_VALIDATION"
  ></app-button-accept-validation-request>
  @if (contract().status === 'SIGNING') {
    <app-upload-signed-contract-button
      [contractId]="contract().id"
      (contractUpdated)="contractUpdated.emit($event)"
    ></app-upload-signed-contract-button>
    <app-yousign-button
      class="warning"
      [action]="requestYousignSignature()"
      (actionResult)="onYousignSignatureRequested()"
      [signatureRequests]="contract().signatureRequests"
      ariaLabel="Demander la signature Yousign"
      *appHasRole="requestYousignSignatureRoles"
    ></app-yousign-button>
  }
}
